import { Unit_fetchForTypes } from './Unit.fetch'
import { IDB_unitTypeRead, IDB_unitTypesReadAll } from '../IDB/IDB.table.unitType'
import type { KnownUnit } from '../../../app-core/lib/unit/unit'
import { map, uniq, mapAsync } from '../../../shared/lib/functional/array.no-deps'
import { pipe } from '../../../shared/lib/functional/pipe.no-deps'
import { barcodeScan } from '../../src/utils/barcode'
import type { AppUnitType } from '../../../shared/domain/units/types.no-deps'
import { type BarcodeResult, cancelled, success, notFound, redirect } from '../../../app-core/lib/unit/barcodeTypes'

const ZAPTIC_PATH_PREFIX = 'zaptic-path:'

export async function Unit_barcodeScanForUnits(units: KnownUnit[]): Promise<BarcodeResult> {
    const code = await barcodeScan()
    if (code == null || code === '') {
        return cancelled()
    }

    if (code.startsWith(ZAPTIC_PATH_PREFIX)) {
        const path = code.slice(ZAPTIC_PATH_PREFIX.length).trim()
        return redirect(path)
    }

    const unitsNotDeleted = units.filter((u) => !u.isDeleted)

    const unitTypes = await pipe(
        unitsNotDeleted,
        map((u) => u.type),
        uniq,
        mapAsync(IDB_unitTypeRead)
    )

    for (const unit of unitsNotDeleted) {
        const unitType = unitTypes.find((ut) => ut?.id === unit.type)

        if (!unitType) {
            continue
        }

        if (getBarcodes(unitType, unit).includes(code)) {
            return success(unit)
        }
    }

    return notFound()
}

export async function Unit_codeLookup(code: string): Promise<KnownUnit> {
    const unitTypes = await IDB_unitTypesReadAll()

    for (const unitType of unitTypes) {
        const unit = await findUnit(unitType, code)
        if (unit != null) return unit
    }
}

async function findUnit(unitType: AppUnitType, code: string) {
    if (unitType.options.lookup == null) return null

    const units = await Unit_fetchForTypes([unitType.id])
    return units.find((unit) => getBarcodes(unitType, unit).includes(code))
}

function getBarcodes(unitType: AppUnitType, unit: KnownUnit): string[] {
    return (unitType.options.lookup || []).map((option) => unit[option.target][option.keyName])
}
